import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-full-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './full-image.component.html',
  styleUrl: './full-image.component.scss'
})
export class FullImageComponent {
  isDisabled: boolean = false;
  @Input() Datas = {
    ProfileImage: null as any,
    ImgPath: null as any,
    Name: null as any,
    Code: null,
    Designation: null,
    ContactNo: null as any,
    MTitle1: null,
    MTitle2: null,
    MData1: null,
    MData2: null,
    Address: null,
    IsAttendanceMatch: null,
    AttendanceMatchPercentage: null,
    Latitude: null,
    Longitude: null,
  };

  constructor(
    private activeModal: NgbActiveModal,
    protected common: CommonService
  ) { }

  close() {
    this.activeModal.close();
  }

  isShow(path: String) {
    return path.includes('EmpDefaultImage.jpg') ? false : true
  }
}
